// React imports
import { Fragment } from 'react';
import PropTypes from 'prop-types';

//  material-ui imports
import { Stack, Typography } from '@mui/material';

// project imports
import FileMngrDialog from './FileMngrDialog';
import fileMngrBytesToSize from '../utils/fileMngrBytesToSize';

// third-party imports
import { useIntl } from 'react-intl';

// ==============================|| FILEMNGR DIALOG VIEW DETAILS ||============================== //

/**
 * FileMngrDialogViewDetails component - Responsible for upload files in the file manager dialog.
 * @author Marcos L. A. Soto <marcosleonildo@gmail.com>
 * @param {Object} props - The component props.
 * @param {boolean} props.openUploadDialog - Flag to control the visibility of the Upload dialog.
 * @param {Function} props.handleCloseUploadDialog - Callback function to handle the close event of the new folder dialog.
 * @param {Function} props.handleRefreshFolder - Callback function to handle the refresh event of the folder.
 * @param {string} props.url - The URL for the API.
 * @returns {JSX.Element} The JSX element representing the new folder dialog component.
 */
const FileMngrDialogViewDetails = ({ openViewDetailsDialog, handleCloseViewDetailsDialog, selectedItem }) => {
    const intl = useIntl();

    const detailsArray = [
        { label: `${intl.formatMessage({ id: 'ui-comp-filemngr-dialog-viewdetails-label-name' })}: `, value: selectedItem?.name },
        {
            label: `${intl.formatMessage({ id: 'ui-comp-filemngr-dialog-viewdetails-label-type' })}: `,
            value: selectedItem?.isFile === true ? selectedItem?.type : 'Folder'
        },
        ...[
            selectedItem?.isFile === true
                ? {
                      label: `${intl.formatMessage({ id: 'ui-comp-filemngr-dialog-viewdetails-label-size' })}: `,
                      value: fileMngrBytesToSize(selectedItem?.size)
                  }
                : null
        ],
        {
            label: `${intl.formatMessage({ id: 'ui-comp-filemngr-dialog-viewdetails-label-date-modified' })}: `,
            value: new Date(selectedItem?.dateModified).toLocaleString()
        },
        {
            label: `${intl.formatMessage({ id: 'ui-comp-filemngr-dialog-viewdetails-label-date-created' })}: `,
            value: new Date(selectedItem?.dateCreated).toLocaleString()
        }
    ].filter((item) => item !== null);

    return (
        <FileMngrDialog title="View Details" isOpen={openViewDetailsDialog} onClose={handleCloseViewDetailsDialog}>
            <Stack spacing={1.5} justifyContent="center" alignItems="center" width={320} p={1}>
                {detailsArray.map((detail, index) => (
                    <Fragment key={index}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                            <div style={{ width: 110 }}>
                                <Typography variant="body1" style={{ opacity: 0.7, textAlign: 'left', flex: '1 auto' }}>
                                    {detail.label}
                                </Typography>
                            </div>
                            <div style={{ flexGrow: 1 }}>
                                <Typography variant="subtitle1" style={{ textAlign: 'left' }}>
                                    &nbsp;{detail.value}
                                </Typography>
                            </div>
                        </Stack>
                    </Fragment>
                ))}
            </Stack>
        </FileMngrDialog>
    );
};

FileMngrDialogViewDetails.propTypes = {
    openViewDetailsDialog: PropTypes.bool,
    handleCloseViewDetailsDialog: PropTypes.func,
    selectedItem: PropTypes.object
};

export default FileMngrDialogViewDetails;
